// extracted by mini-css-extract-plugin
export var box = "_2b-2";
export var checkboxControl = "_2b-0";
export var checkboxRow = "_2b-a";
export var checked = "_2b-3";
export var descriptionSpacer = "_2b-c";
export var disabled = "_2b-4";
export var icon = "_2b-8";
export var input = "_2b-1";
export var labelSpacer = "_2b-b";
export var large = "_2b-7";
export var medium = "_2b-6";
export var small = "_2b-5";
export var text = "_2b-9";